import {http} from '../config'

export default class ExportacaoContabilService {
    ObterLayouts(){
        return http.get('exportacaocontabil/layouts');
    }

    SalvarLayout(modelo){
        return http.post('exportacaocontabil/layouts', modelo);
    }

    AtualizarLayout(id, modelo){
        return http.put(`exportacaocontabil/layouts/${id}`, modelo);
    }

    ExcluirLayout(id){
        return http.delete(`exportacaocontabil/layouts/${id}`);
    }

    DefinirPadrao(id){
        return http.put(`exportacaocontabil/layouts/${id}/padrao`);
    }

    Visualizar(modelo){
        return http.post('exportacaocontabil/visualizacao', modelo);
    }

    GerarArquivo(formato, modelo){
        return http.post(`exportacaocontabil/arquivos/${formato}`, modelo, { responseType: 'blob' });
    }
}
